import React from 'react';
import LazyTable from 'app/component/lazy-table';
import { FilterMatchMode } from 'primereact/api';

const ProductTable: React.FC = () => {
  return LazyTable({
    initialSortField: 'name',
    createUrl: '/create-product',
    labelForCreateEntity: 'Vytvoriť produkt',
    serverUrl: '/api/products/search',
    exportUrl: '/api/products/export',
    editActionAllowed: true,
    globalFilterFields: ['name', 'insuranceCompany.name', 'productType.name'],
    columns: [
      { field: 'id', filter: true, header: 'ID', sortable: true },
      { field: 'name', filter: true, header: 'Názov produktu', sortable: true },
      { field: 'insuranceCompany.name', filterField: 'insuranceCompany', filter: true, header: 'Spoločnosť', sortable: true },
      { field: 'productType.name', filterField: 'productType', filter: true, header: 'Typ produktu', sortable: true },
    ],
    filters: {
      id: { value: null, matchMode: FilterMatchMode.EQUALS },
      name: { value: null, matchMode: FilterMatchMode.CONTAINS },
      insuranceCompany: { value: null, matchMode: FilterMatchMode.CONTAINS },
      productType: { value: null, matchMode: FilterMatchMode.CONTAINS },
    },
  });
};

export default ProductTable;
